export default {
  bagFees: 'Additional bag fees may apply',
}
